import { createGlobalStyle, css } from "styled-components";
import CircularStdBoldOtf from "../resources/fonts/CircularStd-Bold.otf";
import CircularStdBookEot from "../resources/fonts/CircularStd-Book.eot";
import CircularStdBookTtf from "../resources/fonts/CircularStd-Book.ttf";
import CircularStdBookWoff from "../resources/fonts/CircularStd-Book.woff";
import CircularStdBookWoff2 from "../resources/fonts/CircularStd-Book.woff2";

export const mainFontFace = "CircularStd";

const staticStyles = `
    html,
    body {
        overflow: hidden; // prevents the webpage from moving up and down on scrolls
    }

    * {
        margin: 0;
        box-sizing: border-box;
    }

    div,
    span,
    button {
        -webkit-touch-callout: default; /* iOS Safari */
        -webkit-user-select: text; /* Safari */
        -khtml-user-select: text; /* Konqueror HTML */
        -moz-user-select: text; /* Old versions of Firefox */
        -ms-user-select: text; /* Internet Explorer/Edge */
        user-select: text; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
        font-family: ${mainFontFace};
    }

    input,
    textarea {
        -webkit-touch-callout: default; /* iOS Safari */
        -webkit-user-select: text; /* Safari */
        -khtml-user-select: text; /* Konqueror HTML */
        -moz-user-select: text; /* Old versions of Firefox */
        -ms-user-select: text; /* Internet Explorer/Edge */
        user-select: text; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
    }

    textarea:focus,
    input:focus {
        font-size: 16px;
    }

    @font-face {
        font-family: ${mainFontFace};
        src: local(${mainFontFace});
        src: url(${CircularStdBookEot}) format("embedded-opentype");
        src: url(${CircularStdBookWoff2}) format("woff2");
        src: url(${CircularStdBookWoff}) format("woff");
        src: url(${CircularStdBookTtf}) format("truetype");
        font-weight: normal;
    }
    
    @font-face {
        font-family: ${mainFontFace};
        src: url(${CircularStdBoldOtf}) format("opentype");
        font-weight: bold;
    }
`;

const DynamicStyles = createGlobalStyle`${css`
    body {
        font-family: ${mainFontFace};
        color: ${(props) => props.theme.textColorPrimary};
    }
`}`;

export const GlobalStyles = () => (
    <>
        <style>{staticStyles}</style>
        <DynamicStyles />
    </>
);
